import React, { useId } from 'react';

import { Box, TextField, type TextFieldProps } from '@mui/material';

import { IMAGE_UPLOADER_URL } from '~/utils/societePayloadBuilder/constants';
import { PAYLOAD_BUILDER_PLACEHOLDERS } from '~/utils/societePayloadBuilder/placeholders';

import { FieldLabelWithLink } from './FieldLabels';

interface PayloadBuilderTextFieldProps extends Omit<TextFieldProps, 'label'> {
  label: TextFieldProps['label'];
}

export function PayloadBuilderTextField({
  label,
  required,
  fullWidth = true,
  size = 'small',
  ...textFieldProps
}: PayloadBuilderTextFieldProps) {
  return <TextField label={label} required={required} fullWidth={fullWidth} size={size} {...textFieldProps} />;
}

interface PayloadBuilderImageIdFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  placeholder?: string;
  infoText?: string;
}

export function PayloadBuilderImageIdField({
  label,
  value,
  onChange,
  required = false,
  placeholder = PAYLOAD_BUILDER_PLACEHOLDERS.heroImageId,
  infoText,
}: PayloadBuilderImageIdFieldProps) {
  const textFieldId = useId();

  return (
    <Box>
      <FieldLabelWithLink
        label={label}
        required={required}
        href={IMAGE_UPLOADER_URL}
        htmlFor={textFieldId}
        infoText={infoText}
      />
      <TextField
        id={textFieldId}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        required={required}
        fullWidth
        size="small"
      />
    </Box>
  );
}
